import { TPaginationExtra } from "../common";

export interface IFormFieldType {
  _id?: string;

  label: string;
  fieldId: string;
  type:
    | "text"
    | "number"
    | "boolean"
    | "select"
    | "radio"
    | "checkbox"
    | "date"

  placeholder?: string;
  helpText?: string;

  required?: boolean;


  options?: {
    label: string;
    value: string;
  }[];

  children?: string[];

  showIf?: {
    fieldId?: string;
    value?: any;
  };

  errorMessage?: string;


  order?: number;

  status?: boolean;
  deletedAt?: Date | null;

  createdAt?: Date;
  updatedAt?: Date;
}

export interface IFormFieldQuery<T = string | string[]>
  extends TPaginationExtra {
  _id?: T;
  fieldId?: string;
  label?: string;
  type?: string;
  required?: boolean;
  status?: boolean;
}





export const FIELD_TYPES: Array<{ label: string; value: string }> = [
  { label: "Text", value: "text" },
  { label: "Number", value: "number" },
  { label: "Boolean", value: "boolean" },
  { label: "Select", value: "select" },
  { label: "Radio", value: "radio" },
  { label: "Checkbox", value: "checkbox" },
  { label: "Date", value: "date" },
];

// Field types that require options
export const FIELD_TYPES_WITH_OPTIONS = ["select", "radio", "checkbox"];

// Create a form-specific type without MongoDB fields
export interface FormFieldFormData {
  label: string;
  fieldId: string;
  type: string;
  placeholder?: string;
  helpText?: string;
  required?: boolean;
  order?: number;
  options?: Array<{
    label: string;
    value: string | boolean;
  }>;
  errorMessage?: string;
  showIf?: {
    fieldId?: string;
    value?: any;
  };
  status?: boolean;
}

export interface FormFieldProps {
  label: string;
  name: string; // Changed to string to support nested paths
  required?: boolean;
  control: any;
  children: (field: any) => React.ReactNode; // Changed to function that receives field props
}
